<script setup lang="ts">
    import { useEditCoachingFormStore } from '@/js/stores/edit-coaching-form';
    import CheckboxInput from '../CheckboxInput.vue';
    import FormGroup from '../FormGroup.vue';
    import { watch } from 'vue';
    import InputLabel from '../InputLabel.vue';
    import TextInput, { TextInputWidth } from '../TextInput.vue';
    import TextareaInput from '../TextareaInput.vue';
    import { storeToRefs } from 'pinia';
    import { __ } from '@/js/stores/expressions';

    const { formDraft } = storeToRefs(useEditCoachingFormStore());

    watch(
        () => formDraft.value?.useOpenComment,
        () => {
            if (!formDraft.value?.useOpenComment) {
                delete formDraft.value?.openComment;
            } else {
                if (!formDraft.value?.openComment) {
                    formDraft.value.openComment = {
                        title: '',
                        description: '',
                    };
                }
            }
        }
    );
</script>

<template>
    <div v-if="formDraft">
        <FormGroup :help-hint="__('explain', { label: __('coaching-form-open-comment-header') })">
            <template #header>
                {{ __('coaching-form-open-comment-header') }}
            </template>
            <template #help>
                <p>
                    {{ __('coaching-form-open-comment-help-text') }}
                </p>
            </template>

            <CheckboxInput id="form-open-comment" v-model="formDraft.useOpenComment">
                {{ __('coaching-form-use-open-comment') }}
            </CheckboxInput>
        </FormGroup>

        <div
            v-if="formDraft.useOpenComment && formDraft.openComment"
            class="mt-4 bg-gray-extralight p-6 rounded-md"
        >
            <FormGroup>
                <div>
                    <InputLabel for="form-open-comment-title">
                        {{ __('title') }}
                    </InputLabel>
                    <TextInput
                        id="form-open-comment-title"
                        v-model="formDraft.openComment.title"
                        :width="TextInputWidth.Large"
                    />
                </div>
                <div>
                    <InputLabel for="form-open-comment-description">
                        {{ __('description') }}
                    </InputLabel>
                    <TextareaInput
                        id="form-open-comment-description"
                        v-model="formDraft.openComment.description"
                    />
                </div>
            </FormGroup>
        </div>
    </div>
</template>
